import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as action from '../../redux/actions';
import { withRouter } from 'react-router-dom';

function MaysPrimera(string) {
   return string.charAt(0).toUpperCase() + string.slice(1);
}

class Categories extends Component {
   constructor(props) {
      super(props);
      this.state = {};
   }

   componentDidMount() {
      this.props.dispatch(action.get_categories());
   }

   handleClick(categoria, event) {
      document.getElementById('busqueda').value = '';
      if (categoria === 0) {
         this.props.dispatch(action.get_all_catalogo());
      } else {
         this.props.dispatch(action.get_catalogo(categoria));
         if (this.props.history !== '/catalogo') {
            this.props.history.push('/catalogo');
         }
      }
      //event.target.className = "color-selected";
   }

   filters(e) {
      e.preventDefault();
      const form = e.target;

      this.props.dispatch(action.busqueda_catalogo(form.busqueda.value));
   }

   render() {
      return (
         <div className="categories">
            <div className="column">
               <div className="filters column">
                  <div className="titles">
                     <h3 className="color-secondary quicksand">Buscar</h3>
                  </div>
                  <div className="justify-center">
                     <form
                        className="filters-mobile"
                        onSubmit={this.filters.bind(this)}
                     >
                        <div className="inputs">
                           <input
                              id="busqueda"
                              type="text"
                              name="busqueda"
                              className="input-search"
                              placeholder="Producto"
                           />
                           <button className="btn btn-filter" type="submit">
                              <i className="fas fa-search"></i>
                           </button>
                        </div>
                     </form>
                  </div>
                  <div className="white-space-8"></div>
                  <div className="titles">
                     <h3 className="color-secondary quicksand">Categorías</h3>
                  </div>
                  {this.props.categories.map((category, index) => (
                     <div className="options column" key={index}>
                        <div className="justify-center">
                           <div className="inputGroup">
                              <input
                                 id={'option' + index}
                                 name="filter_cat"
                                 value={category.id_categoria}
                                 type="radio"
                                 onClick={this.handleClick.bind(this, category)}
                              />
                              <label htmlFor={'option' + index}>
                                 {MaysPrimera(category.nombre.toLowerCase())}
                              </label>
                           </div>
                        </div>
                     </div>
                  ))}
                  <div className="options column">
                     <div className="justify-center">
                        <div
                           className="inputGroup"
                           onClick={this.handleClick.bind(this, 0)}
                        >
                           <input
                              id="option"
                              name="filter_cat"
                              value="all"
                              type="radio"
                              defaultChecked
                           />
                           <label htmlFor="option">Ver todo</label>
                        </div>
                     </div>
                  </div>
                  {/*<span>
                            {
                                this.props.categories.slice(0, 7).map((category, index) => {
                                    return (
                                        <div className="category-item bordered" key={index}>
                                            <a className={selected === category.id_categoria ? "color-selected" : "link weight-medium"}
                                                onClick={this.handleClick.bind(this, category)}>
                                                {category.nombre}
                                            </a>
                                        </div>
                                    );
                                })
                            }
                            <div className="category-item bordered">
                                <Link to="/catalogo" className="link weight-medium">
                                    VER TODO
                                </Link>
                            </div>
                        </span>*/}
               </div>
               {/*<div className="category-head">
                        <h3 className="color-white">
                            CATEGORIAS
                        </h3>
                    </div>
                    <span>
                        {
                            this.props.categories.slice(0, 7).map(( category, index ) => {
                                return (
                                    <div className="category-item bordered" key = { index }>
                                        <a className={selected === category.id_categoria ? "color-selected" : "link weight-medium"}
                                            onClick={this.handleClick.bind(this, category)}>
                                            { category.nombre }
                                        </a>
                                    </div>
                                );
                            })
                        }
                        <div className="category-item bordered">
                            <Link to="/catalogo" className="link weight-medium">
                                VER TODO
                            </Link>                            
                        </div>
                    </span>*/}
            </div>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      categories: state.categories,
      selected: state.categories_selected,
   };
}

export default withRouter(connect(mapStateToProps)(Categories));



// WEBPACK FOOTER //
// ./src/components/Categories/categories.js